import axiosInstance from '../config/axios.js';

const API_BASE = '/inventory-sku';

const inventorySKUService = {
  // Get all SKUs with optional filters and pagination
  getAll: async (page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get SKU by ID
  getById: async (skuId) => {
    const response = await axiosInstance.get(`${API_BASE}/${skuId}`);
    return response.data;
  },

  // Get all SKUs for a specific inventory item
  getByInventoryId: async (inventoryId) => {
    const response = await axiosInstance.get(`${API_BASE}/inventory/${inventoryId}`);
    return response.data;
  },

  // Create new SKU
  create: async (skuData, skuImage = null) => {
    const formData = new FormData();
    
    // Append all SKU data
    Object.keys(skuData).forEach(key => {
      if (skuData[key] !== null && skuData[key] !== undefined && skuData[key] !== '') {
        formData.append(key, skuData[key]);
      }
    });

    // Append image if provided
    if (skuImage) {
      formData.append('sku_image', skuImage);
    }

    const response = await axiosInstance.post(API_BASE, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Update SKU
  update: async (skuId, skuData, skuImage = null) => {
    const formData = new FormData();
    
    // Append all SKU data
    Object.keys(skuData).forEach(key => {
      if (skuData[key] !== null && skuData[key] !== undefined && skuData[key] !== '') {
        formData.append(key, skuData[key]);
      }
    });

    // Append image if provided
    if (skuImage) {
      formData.append('sku_image', skuImage);
    }

    const response = await axiosInstance.put(`${API_BASE}/${skuId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete SKU
  delete: async (skuId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${skuId}`);
    return response.data;
  },

  // Get out of stock SKUs
  getOutOfStock: async () => {
    const response = await axiosInstance.get(`${API_BASE}/out-of-stock`);
    return response.data;
  },

  // Get SKU image URL
  getSKUImage: (skuId) => {
    return `${axiosInstance.defaults.baseURL}${API_BASE}/${skuId}/sku-image`;
  }
};

export default inventorySKUService;